export const PR_PT = "PR_PT";
export const PR_PPT = "PR_PPT";
export const FREQUENCY = "INPUT_MODE";
export const PREMIUM = "PR_ANNPREM";
export const PR_SA = "PR_SA";